import { useAuthUser } from 'auth/hooks';
import { PricingHelper } from 'pricing/helpers';

export const useCostDecimals = (): number => {
  const { user } = useAuthUser();

  return user?.companySettings?.costDecimals ?? PricingHelper.DEFAULT_COST_DECIMALS;
};
